import React from "react";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

export default function UserBuzzBucks({ currentBalance, lifetimeReceived, lifetimeTradedIn }) {
  const classes = useStyles();
  
  return (
    <Box className={classes.statsContainer}>
      <Box className={classes.statRow}>
        <Box className={classes.statItem}>
          <Typography variant="body2" className={classes.statLabel}>
            You have
          </Typography>
          <Typography className={classes.firstStatValue}>
            {currentBalance}
          </Typography>
          <Typography variant="body2" className={classes.statLabel}>
            BuzzBucks
          </Typography>
        </Box>
      </Box>
      <Box className={classes.statRow}>
        <Box className={classes.statItem}>
          <Typography variant="body2" className={classes.statLabel}>
            Lifetime Received
          </Typography>
          <Typography variant="h5" className={classes.statValue}>
            {lifetimeReceived}
          </Typography>
        </Box>
        <Box className={classes.statItem}>
          <Typography variant="body2" className={classes.statLabel}>
            Traded In
          </Typography>
          <Typography variant="h5" className={classes.statValue}>
            {lifetimeTradedIn}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  statsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    width: "100%",
  },
  statRow: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(2),
    width: "100%",
  },
  statItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(1.5),
    backgroundColor: "#f5f5f5",
    borderRadius: theme.shape.borderRadius,
    flex: 1,
  },
  statLabel: {
    color: "rgb(135, 131, 131)",
    marginBottom: theme.spacing(0.5),
    fontSize: "0.875rem",
    fontWeight: 500,
  },
  statValue: {
    color: "rgb(100, 100, 100)",
    fontWeight: "bold",
    fontSize: "1.5rem",
  },
  firstStatValue: {
    color: "rgb(100, 100, 100)",
    fontWeight: "bold",
    fontSize: "36px",
  },
}));
